import illustration from '../../../../shared/assets/ppc-compliance-in-progress-stub-illustration.svg'
import React from 'react'
import sendReportIllustration from '../../../../shared/assets/send-report-button-illustration.svg'

export const TabInProgressStub = () => {
  return (
    <div className={'flex justify-center'}>
      <div className={'flex w-full max-w-[320px] flex-col items-center gap-[24px]'}>
        <div className={'w-full'}>
          <img alt={'Illustration'} className={'mx-auto max-w-full'} src={illustration} />
        </div>
        <div className={'flex w-full flex-col gap-[24px]'}>
          <div className={'flex w-full flex-col gap-[16px]'}>
            <div className={'flex flex-col items-center'}>
              <h2 className={'text-center text-[24px]'}>No data</h2>
            </div>
            <div
              className={'flex w-full flex-col gap-[16px] rounded-[16px] bg-focus/[0.06] p-[16px]'}
            >
              <p className={'text-focus-500'}>
                Once you&apos;ve warned a newly found affiliate, manually move them from
                &quot;New&quot; to &quot;In Progress&quot; to keep track of their status
              </p>
            </div>
          </div>
          <div className={'flex flex-col items-center justify-center gap-[8px]'}>
            <p className={'max-w-[254px] text-center text-[13px] leading-[18px] text-[#8E7CA7]'}>
              💡 A tip: you can move them manually or{' '}
              <span className={'font-semibold'}>send them a report</span> from Bluepear to update
              their status automatically
            </p>
            <div className={'flex justify-center'}>
              <img alt={'Send report'} src={sendReportIllustration} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
